var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10656_120489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10656_120489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.8333V3.5H12.8333V12.8333H3.5ZM5.83333 10.5H10.5V5.83333H5.83333V10.5ZM3.5 24.5V15.1667H12.8333V24.5H3.5ZM5.83333 22.1667H10.5V17.5H5.83333V22.1667ZM15.1667 12.8333V3.5H24.5V12.8333H15.1667ZM17.5 10.5H22.1667V5.83333H17.5V10.5ZM22.1667 24.5V22.1667H24.5V24.5H22.1667ZM15.1667 17.5V15.1667H17.5V17.5H15.1667ZM17.5 19.8333V17.5H19.8333V19.8333H17.5ZM15.1667 22.1667V19.8333H17.5V22.1667H15.1667ZM17.5 24.5V22.1667H19.8333V24.5H17.5ZM19.8333 22.1667V19.8333H22.1667V22.1667H19.8333ZM19.8333 17.5V15.1667H22.1667V17.5H19.8333ZM22.1667 19.8333V17.5H24.5V19.8333H22.1667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.77167022c798887a97f1170d1a6f07e7.svg";
export { ForwardRef as ReactComponent };